import { z } from 'zod';
import {
  makeCreateWidgetAction,
  type MakeCreateWidgetActionDeps,
  type WidgetActionProcessor,
  type WidgetActionSchema,
} from '@/entities/widget';
import {
  BehindTheAnswerWidgetSchema,
  BehindTheAnswerWidgetKey,
} from '@inference.engine/widgets/web';

/**
 * Factory that binds the BehindTheAnswer widget processor to the supplied
 * dep surface. Co-resident with AudienceFlowWidget under the
 * `features/audience-flow-widget` umbrella as a sibling sub-widget, with zero
 * cross-imports between them.
 */
export const makeProcessors = (deps: MakeCreateWidgetActionDeps): WidgetActionProcessor[] => {
  const create: WidgetActionProcessor<
    WidgetActionSchema<z.infer<typeof BehindTheAnswerWidgetSchema>>
  > = {
    key: BehindTheAnswerWidgetKey,
    processor: makeCreateWidgetAction(deps) as WidgetActionProcessor<
      WidgetActionSchema<z.infer<typeof BehindTheAnswerWidgetSchema>>
    >['processor'],
  };
  return [create];
};
